import configApp from "./config-app";
import configCore from "./config-core";

let config = {
    endpoints: {
       backend: 'https://prod-backend-gci.saladegestao.com/'
    },
    tests: {
        login: "admin@admin",
        password: "temp##988"
    },
    gmaps_key: 'AIzaSyDTNW3Z7vNAc7V-ze1_X_2VbucOFs0CbC4',
    tokens: {
        recaptcha_secret:  '6Lea6vQrAAAAABEsBQfjQDw1PeM335UQsAnWYNcM'
    },
    bucketS3: {
        accessKeyId: 'AKIA4AQ3UPPMHTOFDJGR',
        secretAccessKey: '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',
        region: 'us-east-1', 
        bucket: 'demonstracao-zellus.cc',
        path_default: 'incorporadora.cloud'
    },
    ...configCore,
    ...configApp,
    routesNoAuth: [...configCore.routesNoAuth,...configApp.routesNoAuth]
}
export default config;
